import http from '../../utils/fetch';
export default {
    queryData(usercode) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/selectByUsercode',
            method: 'post',
            params: {usercode}
        });
    },
    update(v) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/update',
            method: 'post',
            data: v
        });
    },
    reUpdate(taskid) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/reUpdate',
            method: 'post',
            params: {taskid}
        });
    },
    zancun(v) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/zancun',
            method: 'post',
            data: v
        });
    },
}